import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ServicoEntrega } from '../models/servico-entrega';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class ServicoEntregaService {

  constructor(private http: HttpClient) { }

  salvar(servicoEntrega: ServicoEntrega) {
    return this.http.post(globals.apiUrl + '/api/ServicoEntrega/Salvar', servicoEntrega);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/ServicoEntrega/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorIdServicoEntrega(id) {
    return this.http.get<any>(globals.apiUrl + '/api/ServicoEntrega/Buscar',
      { params: new HttpParams().set('id', id) });
  }


  consultarListaServicosEntrega() {
    return this.http.get<ServicoEntrega[]>(globals.apiUrl + '/api/ServicoEntrega/Lista');
  }

  consultarServicoEntregaComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    return this.http.get<any>(globals.apiUrl + '/api/ServicoEntrega/ListaPag',
      {
        params: parametros
      });
  }

}
